// 로컬 전용 배지장 + 자기기록 (§5·§8). localStorage만 — 서버 저장 0, 무흔적 유지.

import type { Archetype } from "./types";

const KEY = "bwek.local.v1";

interface LocalStore {
  best: number; // 자기 최고 점수
  badges: Partial<Record<Archetype, number>>; // 유형별 수집 횟수
  plays: number;
}

const EMPTY: LocalStore = { best: 0, badges: {}, plays: 0 };

function read(): LocalStore {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? { ...EMPTY, ...JSON.parse(raw) } : { ...EMPTY };
  } catch {
    return { ...EMPTY };
  }
}

function write(store: LocalStore): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(store));
  } catch {
    // 저장 실패는 조용히 무시(프라이빗 모드 등).
  }
}

/** 한 판 기록. 신기록 갱신 여부 반환. */
export function record(score: number, archetype: Archetype): { isBest: boolean; best: number } {
  const store = read();
  const isBest = score > store.best;
  store.best = Math.max(store.best, score);
  store.badges[archetype] = (store.badges[archetype] ?? 0) + 1;
  store.plays += 1;
  write(store);
  return { isBest, best: store.best };
}

export function getStats(): LocalStore {
  return read();
}

export function reset(): void {
  write({ ...EMPTY });
}
